import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { toPairs } from 'ramda';
import UrlPattern from 'url-pattern';

import { saveBackUrl } from 'actions/userActions';
import * as routes from 'constants/routes';

@connect(null, { saveBackUrl })
export class GuestRedirect extends Component {
    componentDidMount() {
        const { location: { pathname, search }, saveBackUrl } = this.props;
        const isValidRoute = toPairs(routes).some(
            ([, route ]) => route instanceof UrlPattern && route.match(pathname)
        );

        if (isValidRoute) {
            saveBackUrl(`${pathname}${search || ''}`);
        }
    }

    render () {
        return <Redirect to={routes.login.path} />;
    }
}
